export const ADMIN_BASE = '/031ca7a4-c358-4dfc-b7bb-746882378f6c';
export const ADMIN_LOGIN = `${ADMIN_BASE}/login`;
export const ADMIN_MAGIC_LINKS = `${ADMIN_BASE}/magic-links`;

export const ORGANIZER_BASE = '/b4e2c8f1-3a7d-4b9e-c2f5-6a1d3e9b0c4f';
export const ORGANIZER_LOGIN = `${ORGANIZER_BASE}/login`;
